import { Link } from "gatsby"
import React from "react"
import "./header.scss"

const Header = () => (
  <header className="c-header">
    <Link to="/" className="c-header-link">
      <h1 className="c-header-title">これを読もう！</h1>
    </Link>
    <p className="c-header-subTitle">ITベンチャーで働く20代の読書記録</p>
  </header>
)

export default Header
